export default "__VITE_ASSET__CZtAwrL2__"